<p-panel>
  <div class="d-flex justify-content-between align-content-center">
    <div>
      <h4 *ngIf="flag === 'edit'">Actualizar Recordatorio de Análisis</h4>
      <h4 *ngIf="flag === 'new'">Crear Recordatorio de Análisis</h4>
    </div>
    <input type="file" #adjuntarAnalisis (change)="fileChange($event)" style="display: none;" />
    <button *ngIf="model?.estado === 'Realizada'" class="btn" [class.btn-info]="model.adjunto"
      [class.btn-success]="!model.adjunto" (click)="model.adjunto ? verAdjunto(): readUrl(adjuntarAnalisis)">
      <i class="pi" [class.pi-check-circle]="model.adjunto" [class.pi-times-circle]="!model.adjunto"></i>
      {{model.adjunto ? 'Análisis adjuntado' : 'Análisis no adjuntado'}}
    </button>
  </div>

  <app-form-builder #mainForm [model]="model" [undoEnabled]="undoEnabled" [distributionColumns]="3"
    [fields]="formFields" (selectAll)="selectAll()" (formChanges)="formChanges($event)">
  </app-form-builder>

  <br>

  <h4>Datos del suelo</h4>
  <app-form-builder [model]="model" [undoEnabled]="undoEnabled" [distributionColumns]="3"
    [fields]="formFieldsDatosSuelo" (formChanges)="formChanges($event)">
  </app-form-builder>
  <br>

  <h4 *ngIf="this.applicationType === 'viverogest'">Resultados del Análisis</h4>
  <app-form-builder *ngIf="this.applicationType === 'viverogest'" #mainForm [model]="model" [undoEnabled]="undoEnabled"
    [distributionColumns]="3" [fields]="formFieldsResultadosAnalisis" (selectAll)="selectAll()"
    (formChanges)="formChanges($event)">
  </app-form-builder>

  <br>

  <div *ngIf="(type === 0 || type === 2) && model?.fechaSiguiente" class="d-flex align-content-center small">
    <p-toggle-switch [(ngModel)]="shouldCreateNextAnalisis">
    </p-toggle-switch>
    <span class="ml-2">
      Crear también el análisis siguiente (programado para el día {{model.fechaSiguiente}})
    </span>
  </div>

  <br>

  <div class="d-flex justify-content-center">
    <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
    
    <app-request-button (click)="submit()" [mode]="requestButtonType" [lockOnSuccess]="true" [request]="request">
    </app-request-button>
  </div>
</p-panel>

<br>